import type { Identifier } from "ra-core";
import { useGetList, useGetMany } from "ra-core";

import {
  agreementWarnings,
  type AgreementCheck,
  type FirstOrder,
} from "./agreementData";

// The checks and first order deadline of some agreements, by agreement id
export const useAgreementWarnings = (ids: Identifier[]) => {
  const { data: checks = [] } = useGetMany<AgreementCheck>(
    "agreement_checks",
    { ids },
    { enabled: ids.length > 0 },
  );
  const { data: firstOrders = [] } = useGetList<FirstOrder>(
    "agreement_first_order",
    {
      pagination: { page: 1, perPage: ids.length || 1 },
      sort: { field: "id", order: "ASC" },
      filter: { "id@in": `(${ids.join(",")})` },
    },
    { enabled: ids.length > 0 },
  );
  return (id: Identifier) =>
    agreementWarnings(
      checks.find((check) => check.id === id),
      firstOrders.find((order) => order.id === id),
    );
};
